module.exports = __webpack_public_path__ + "static/media/coreteam04.6d67743e.png";